module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "announcement-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.title),
      expression: "entity.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "announcement-title",
      "type": "text",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.entity.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "announcement-body"
    }
  }, [_vm._v("Body")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "branch-announcement-body"
    },
    model: {
      value: (_vm.entity.body),
      callback: function($$v) {
        _vm.$set(_vm.entity, "body", $$v)
      },
      expression: "entity.body"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "bio"
    }
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('image-uploader', {
    on: {
      "changeFile": _vm.$_coverChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label",
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Files")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileUploadedSuccess,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.dropzone.dropzone.element.click()
      }
    }
  }, [_vm._v("\n                        Select File\n                      ")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "announcement-publish"
    }
  }, [_vm._v("Publish Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.publish_date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "publish_date", $$v)
      },
      expression: "entity.publish_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "announcement-unpublish"
    }
  }, [_vm._v("Unpublish Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('datepicker', {
    attrs: {
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity.unpublish_date),
      callback: function($$v) {
        _vm.$set(_vm.entity, "unpublish_date", $$v)
      },
      expression: "entity.unpublish_date"
    }
  })], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      Save\n      "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n        Announcements modified successfully!\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.saveErrorMessage) + "\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Create Announcements")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3868c784","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/branchOffices/sections/announcements/New.vue
// module id = 869
// module chunks = 0